// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast } = useToast();

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [listData, setListData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        showToast("Loading", "loading");

        const url = apiUrl.apiUrl + '/acc/profit-center/list/'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleDelete = (row: any) => {
        showToast("Loading", "loading");
        const url = apiUrl.apiUrl + '/acc/profit-center/delete/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast("Berhasil menghapus data", "success");
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 50,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title='Preview' placement='top'>
                        <Box>
                            <IconButton onClick={() => navigate('/acc/profitcenter/detail/' + row.id)}>
                                <Icon icon='mdi:search' color='#909090' />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title='Hapus' placement='top'>
                        <Box>
                            <IconButton onClick={() => handleDelete(row)}>
                                <Icon icon='mdi:trash' color='#df1d1d' />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            )
        }
    ]

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MASTER PROFITCENTER' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/acc/profitcenter/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    {loading ? (
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                        </Grid>
                    ) : (
                        <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['id']} />
                    )}
                </div>
            </Grid>
        </Grid>
    )
}
